webpackJsonp([0],{

/***/ "/0D4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"CountDown__sec__afgUg29H","label":"CountDown__label__1JBJj3J3","time":"CountDown__time__6yG3-m3c"};

/***/ }),

/***/ "/3Ro":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"SearchBox__sec__1zYDrC3C","search_box":"SearchBox__search_box__-YOE_-6A","search":"SearchBox__search__f2pJ-eMo","hide":"SearchBox__hide__1zXFku_P","show":"SearchBox__show__3U0LKYtQ"};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("qMEF");


/***/ }),

/***/ "1HjY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserInfo_1 = __webpack_require__("TrZ9");
exports.default = UserInfo_1.default;


/***/ }),

/***/ "2IiS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"Rules__sec__39a9t0ie"};

/***/ }),

/***/ "3rPh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NewUserTitle_1 = __webpack_require__("y0tF");
exports.default = NewUserTitle_1.default;


/***/ }),

/***/ "5vST":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Dynamics_1 = __webpack_require__("I/Ab");
exports.default = Dynamics_1.default;


/***/ }),

/***/ "69qh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("XnEg");
var MyPackage = /** @class */ (function (_super) {
    tslib_1.__extends(MyPackage, _super);
    function MyPackage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.myPackage = function () {
            window.Global.isLogin(function () {
                var descdom = window._CONFIG['PACKAGELINKS'].join("");
                new f2eGameUI.Task.PackageDialog({
                    actId: window._CONFIG['ACTCODE'],
                    dependComponents: {
                        package: {
                            pageSize: 5,
                            readyText: "加载中..",
                            desc: descdom
                        },
                        dialog: {
                            classNames: {
                                component: "package-pop"
                            }
                        }
                    }
                });
            });
        };
        return _this;
    }
    MyPackage.prototype.render = function () {
        var className = this.props.className;
        var classNameSec = classnames(styles.sec, className);
        return (React.createElement("div", { className: classNameSec, onClick: this.myPackage }));
    };
    MyPackage = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], MyPackage);
    return MyPackage;
}(React.Component));
exports.MyPackage = MyPackage;
exports.default = MyPackage;


/***/ }),

/***/ "C1vT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var global = {
    QD: "",
    AW: "",
    QD_DESC: "",
    AW_DESC: "",
    baseNcImgUrl: "http://img.game.dwstatic.com/f2e/static/activity/yygame/wbtg/new/images" || "nc",
    statpidOption: {
        eid: "",
        eid_desc: "",
        gam: "",
        gse: ""
    },
    init: function () {
        this.getQDAW();
        var option = {
            pro: 'yygame',
            eid: "login/" + this['QD'] + "/TGDS/" + this['AW'] + "/NEW",
            eid_desc: "\u767B\u5F55/" + this['QD_DESC'] + "/\u53EC\u5524\u597D\u53CB/" + this['AW_DESC'] + "/\u65B0\u7528\u6237",
            rso: document.location.href,
            rso_desc: '推广大使'
        };
        this.statpidOption = {
            eid: "click/" + this['QD'] + "/TGDS/" + this['AW'],
            eid_desc: "\u70B9\u51FB/" + this['QD_DESC'] + "/\u53EC\u5524\u597D\u53CB/" + this['AW_DESC'],
            gam: "default",
            gse: "default"
        };
        // $.f2e.util.statpid.loginStat(option);
        f2eGame.port.statpid.loginStat(option);
    },
    getQDAW: function () {
        //获取渠道，属性
        var codeString = f2eGame.util.getParam("code");
        var QD = this['defaultQD'] = Object.keys(window._CONFIG['QD'])[0];
        var AW = this['defaultAW'] = Object.keys(window._CONFIG['AW'])[0];
        if (codeString && codeString.indexOf('IV') >= 0) {
            QD = codeString.split('IV')[0];
            AW = codeString.split('IV')[1];
        }
        this['QD'] = QD;
        this['AW'] = AW;
        this['QD_DESC'] = window._CONFIG['QD'][QD];
        this['AW_DESC'] = window._CONFIG['AW'][AW];
    },
    isLogin: function (callback) {
        f2eGame.port.udb.isLogin()
            .then(function (res) {
            if (res) {
                callback();
            }
            else {
                f2eGame.port.udb.login({
                    type: "YYQ"
                });
            }
        });
    }
};
exports.default = global;


/***/ }),

/***/ "FEAO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SearchBox_1 = __webpack_require__("VhSe");
exports.default = SearchBox_1.default;


/***/ }),

/***/ "GOFa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var ReactDOM = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("g/92");
var fetch_1 = __webpack_require__("l51b");
var subpub = __webpack_require__("lZMG");
var components_1 = __webpack_require__("OrGm");
var BindFriends = /** @class */ (function (_super) {
    tslib_1.__extends(BindFriends, _super);
    function BindFriends(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCurBind = function () {
            var curBindUser = _this.props.curBindUser;
            if (!!curBindUser.yyuid) {
                return (React.createElement("li", null,
                    React.createElement("div", { className: styles.cur }),
                    React.createElement("div", { className: styles.totalticket },
                        "\u7D2F\u8BA1\u9001\u7968\uFF1A",
                        React.createElement("span", null, curBindUser.scores)),
                    React.createElement("div", { className: styles.friend_pic, title: curBindUser.nickname },
                        React.createElement("img", { src: "http://image.open.yy.com/avatar/" + curBindUser.yyuid, alt: "", width: "84", height: "84" }),
                        React.createElement("div", { className: styles.pic_mask })),
                    React.createElement("div", { className: styles.btn_send, onClick: _this.voteTicket })));
            }
        };
        _this.voteTicket = function () {
            var _a = _this.props, userInfo = _a.userInfo, confData = _a.confData;
            if (_this.props.userInfo.tickets == 0) {
                var tasksNum_1 = 0;
                var tasks_1 = [], games_1 = [], servers_1 = [], x_1 = [], y_1 = [];
                confData.map(function (item, index) {
                    item.tasks.map(function (task, i) {
                        if (task.taskStatus != 100) {
                            tasksNum_1++;
                            tasks_1.push(task);
                            games_1.push(item.gameId);
                            servers_1.push(item.serverId);
                            x_1.push(index);
                            y_1.push(i);
                        }
                    });
                });
                if (tasksNum_1 > 0) {
                    var dialog_1 = new f2eGameUI.Dialog({
                        classNames: {
                            component: "min-pop"
                        },
                        content: "\u60A8\u5F53\u524D\u6CA1\u6709\u6E38\u620F\u7968\uFF0C<br/>\u4F53\u9A8C\u6E38\u620F\u5373\u53EF\u83B7\u5F97\u6E38\u620F\u7968\u54E6\uFF01",
                        buttons: [{
                                className: 'btn-getAward',
                                callback: function () {
                                    var options = {
                                        taskId: tasks_1[0].id,
                                        gameId: games_1[0],
                                        serverId: servers_1[0],
                                        taskName: tasks_1[0].showName,
                                        x: x_1[0],
                                        y: y_1[0],
                                        noTips: true,
                                        isClick: false
                                    };
                                    subpub.emit('getTaskAward', options);
                                    dialog_1.close(true);
                                }
                            }]
                    });
                }
                else {
                    var dialog_2 = new f2eGameUI.Dialog({
                        classNames: {
                            component: "min-pop"
                        },
                        content: "\u672C\u65E5\u5DF2\u5B8C\u6210\u5168\u90E8\u4EFB\u52A1\uFF0C\u8BF7\u660E\u65E5\u518D\u63A5\u518D\u5389~",
                        buttons: [{
                                className: 'btn-y',
                                callback: function () {
                                    dialog_2.close(true);
                                }
                            }]
                    });
                }
            }
            else {
                var cont_1 = "";
                fetch_1.voteTicket()
                    .then(function (res) {
                    if (res.status == 200 && res.data == true) {
                        cont_1 = "投票成功";
                        subpub.emit('voteSucc');
                    }
                    else {
                        cont_1 = "投票失败";
                    }
                    var dialog = new f2eGameUI.Dialog({
                        classNames: {
                            component: "min-pop"
                        },
                        content: cont_1,
                        buttons: [{
                                className: "btn-y",
                                callback: function () {
                                    dialog.close(true);
                                }
                            }]
                    });
                });
            }
        };
        // 更换绑定、
        _this.changeBind = function (yyuid) {
            // this.setState({curYyuid:yyuid,searchValue:passport});
            var shareYyuid = Number(yyuid);
            var curBindYyuid = _this.props.curBindUser.yyuid;
            if (!!shareYyuid) {
                if (curBindYyuid == shareYyuid)
                    return;
                var dialog_3 = new f2eGameUI.Dialog({
                    classNames: {
                        component: "min-pop"
                    },
                    buttons: [{
                            className: "btn-nobind",
                            callback: function () {
                                dialog_3.close(true);
                            }
                        }, {
                            className: "btn-bind",
                            callback: function () {
                                _this.bind(shareYyuid);
                                dialog_3.close(true);
                            }
                        }]
                });
                var contTips = "";
                if (!!curBindYyuid) {
                    contTips = "\u662F\u5426\u89E3\u9664\u5DF2\u6709\u7ED1\u5B9A\uFF0C\u5E76\u7ED1\u5B9A" + shareYyuid + "\u4E3A\u60A8\u65B0\u7684\u7ED1\u5B9A\u597D\u53CB\uFF1F";
                }
                else {
                    contTips = "\u662F\u5426\u7ED1\u5B9ATA\u4E3A\u60A8\u7684\u6E38\u620F\u597D\u53CB\u3002\u7ED1\u5B9A\u540E\u5C06\u81EA\u52A8\u4E3ATA\u6295\u7968";
                }
                ReactDOM.render(React.createElement(components_1.Dialog, { shareYyuid: shareYyuid, curBindYyuid: curBindYyuid, contTips: contTips }), $('.f2e-dialog__body ')[0]);
            }
        };
        _this.resolveAnimationFrame = function (dec) {
            var length = _this.props.historyBindUser.length;
            // let length=4;
            if (!!_this.props.curBindUser.yyuid && length > 2) {
                var width_1 = (length - 1) * 156;
                if (dec == "right") {
                    if (_this.state.left == -width_1) {
                        return;
                    }
                    var move_1 = 0;
                    var timer_1 = setInterval(function () {
                        if (_this.state.left > -width_1 && move_1 < 156) {
                            _this.setState({
                                left: _this.state.left - 1
                            });
                            move_1++;
                        }
                        else {
                            clearInterval(timer_1);
                        }
                    }, 1);
                }
                else {
                    if (_this.state.left == 0) {
                        return;
                    }
                    var move_2 = 0;
                    var timer_2 = setInterval(function () {
                        if (_this.state.left < width_1 && move_2 < 156) {
                            _this.setState({
                                left: _this.state.left + 1
                            });
                            move_2++;
                        }
                        else {
                            clearInterval(timer_2);
                        }
                    }, 1);
                }
            }
            else {
                return;
            }
        };
        _this.state = {
            left: 0
        };
        return _this;
    }
    // componentWillReceiveProps(nextProps) {
    //     if(!!nextProps.curBindUser.yyuid){   
    //         f2eGame.port.udb.getUserInfo()
    //         .then((res)=>{
    //             this.setState({passport:res.passport})                 
    //         })
    //     }
    // }
    BindFriends.prototype.componentWillUpdate = function () {
        // requestAnimationFrame(this.resolveAnimationFrame);
    };
    BindFriends.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, historyBindUser = _a.historyBindUser, curBindUser = _a.curBindUser;
        var left = this.state.left;
        var classNameSec = classnames(styles.sec, className);
        return (React.createElement("div", { className: classNameSec },
            React.createElement("div", { className: styles.btn_left, onClick: function (e) { return (_this.resolveAnimationFrame("left")); } }),
            React.createElement("div", { className: styles.content },
                React.createElement("ul", { style: { left: left } },
                    this.renderCurBind(),
                    historyBindUser.map(function (item, index) { return _this.renderHistory(item, index); }),
                    React.createElement("li", null,
                        React.createElement("div", { className: styles.add_pic })))),
            React.createElement("div", { className: styles.btn_right, onClick: function (e) { return (_this.resolveAnimationFrame('right')); } })));
    };
    BindFriends.prototype.renderHistory = function (item, index) {
        var _this = this;
        if (!!item.yyuid) {
            return (React.createElement("li", null,
                React.createElement("div", { className: styles.nocur }),
                React.createElement("div", { className: styles.totalticket },
                    "\u7D2F\u8BA1\u9001\u7968\uFF1A",
                    React.createElement("span", null, item.scores)),
                React.createElement("div", { className: styles.friend_pic, title: item.nickname },
                    React.createElement("img", { src: "http://image.open.yy.com/avatar/" + item.yyuid, alt: "", width: "84", height: "84" }),
                    React.createElement("div", { className: styles.pic_mask })),
                React.createElement("div", { className: styles.btn_changebind, onClick: function (e) { return (_this.changeBind(item.yyuid)); } })));
        }
        else {
            return null;
        }
    };
    BindFriends.prototype.bind = function (yyuid) {
        fetch_1.bindFriend(yyuid)
            .then(function (res) {
            var cont = "";
            if (res.status == 200 && res.data) {
                cont = "绑定成功！";
                subpub.emit('bindSucc');
            }
            else if (res.status == 551) {
                cont = res.message;
            }
            else {
                cont = "绑定失败！";
            }
            var dialog = new f2eGameUI.Dialog({
                classNames: {
                    component: "min-pop"
                },
                content: cont,
                buttons: [{
                        className: "btn-y",
                        callback: function () {
                            dialog.close(true);
                        }
                    }]
            });
        });
    };
    BindFriends = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], BindFriends);
    return BindFriends;
}(React.Component));
exports.BindFriends = BindFriends;
exports.default = BindFriends;


/***/ }),

/***/ "HEzI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MyPackage_1 = __webpack_require__("69qh");
exports.default = MyPackage_1.default;


/***/ }),

/***/ "HJRu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BindFriends_1 = __webpack_require__("GOFa");
exports.default = BindFriends_1.default;


/***/ }),

/***/ "I/Ab":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("mt4q");
var Dynamics = /** @class */ (function (_super) {
    tslib_1.__extends(Dynamics, _super);
    function Dynamics(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            point: 0,
        };
        return _this;
    }
    Dynamics.prototype.componentDidMount = function () {
        var dynamics = new f2eGameUI.Task.AwardScroll({
            $element: $(this.refs.dynamics)[0],
            actID: window._CONFIG['ACTCODE'],
            presetData: window._CONFIG['RANKINGS'],
            showHead: false,
            showTime: false,
            beforeRender: function (dynamics) {
                dynamics.data.forEach(function (ele) {
                    ele.nickname = "<span>\u606D\u559C " + ele.nickname + " \u83B7\u5F97\u4E86 </span>";
                });
            }
        });
    };
    Dynamics.prototype.render = function () {
        var className = this.props.className;
        var point = this.state.point;
        var classNameSec = classnames(styles.sec, className);
        return (React.createElement("div", { className: classNameSec, ref: "dynamics" }));
    };
    Dynamics = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], Dynamics);
    return Dynamics;
}(React.Component));
exports.Dynamics = Dynamics;
exports.default = Dynamics;


/***/ }),

/***/ "I2I8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"App__container__sGqxYo3q","top":"App__top__CQ-A_XLo","sidebar":"App__sidebar__hXjRzSqf","main":"App__main__3buZsuFW","bottom":"App__bottom__1HEXuM40","bottom_left":"App__bottom_left__bOfuCCei","bottom_right":"App__bottom_right__3DKOsbta","rule_package":"App__rule_package__3ZL5wNw4"};

/***/ }),

/***/ "IBFw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PagesLinks_1 = __webpack_require__("TsEa");
exports.default = PagesLinks_1.default;


/***/ }),

/***/ "NX9E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PointInfo_1 = __webpack_require__("YDwv");
exports.default = PointInfo_1.default;


/***/ }),

/***/ "OdH7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Rules_1 = __webpack_require__("xFlA");
exports.default = Rules_1.default;


/***/ }),

/***/ "OrGm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CountDown_1 = __webpack_require__("alqh");
exports.CountDown = CountDown_1.default;
var Dynamics_1 = __webpack_require__("5vST");
exports.Dynamics = Dynamics_1.default;
var NewUserTitle_1 = __webpack_require__("3rPh");
exports.NewUserTitle = NewUserTitle_1.default;
var NewUserTask_1 = __webpack_require__("nQQ4");
exports.NewUserTask = NewUserTask_1.default;
var PointInfo_1 = __webpack_require__("NX9E");
exports.PointInfo = PointInfo_1.default;
var SearchBox_1 = __webpack_require__("FEAO");
exports.SearchBox = SearchBox_1.default;
var BindFriends_1 = __webpack_require__("HJRu");
exports.BindFriends = BindFriends_1.default;
var Dialog_1 = __webpack_require__("Wska");
exports.Dialog = Dialog_1.default;
var PagesLinks_1 = __webpack_require__("IBFw");
exports.PagesLinks = PagesLinks_1.default;
var MyPackage_1 = __webpack_require__("HEzI");
exports.MyPackage = MyPackage_1.default;
var Rules_1 = __webpack_require__("OdH7");
exports.Rules = Rules_1.default;
var UserInfo_1 = __webpack_require__("1HjY");
exports.UserInfo = UserInfo_1.default;


/***/ }),

/***/ "TrZ9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("qbvT");
var UserInfo = /** @class */ (function (_super) {
    tslib_1.__extends(UserInfo, _super);
    function UserInfo(props) {
        var _this = _super.call(this, props) || this;
        _this.renderInfo = function () {
            var userName = _this.state.userName;
            if (!!userName) {
                return (React.createElement("div", { className: styles.logoutneara },
                    React.createElement("span", { className: styles.username }, userName),
                    React.createElement("a", { className: styles.logout, onClick: function (e) { return f2eGame.port.udb.logout(); } }, "\u6CE8\u9500")));
            }
            else {
                return (React.createElement("div", { className: styles.logineara },
                    React.createElement("a", { className: styles.login, onClick: function (e) { return f2eGame.port.udb.login({
                            type: "YYQ"
                        }); } }, "\u767B\u5F55")));
            }
        };
        _this.state = {
            userName: ""
        };
        return _this;
    }
    UserInfo.prototype.componentWillMount = function () {
        var _this = this;
        window.Global.isLogin(function () {
            f2eGame.port.udb.getUserInfo()
                .then(function (res) {
                _this.setState({
                    userName: res.nickName
                });
            });
        });
    };
    UserInfo.prototype.render = function () {
        var className = this.props.className;
        var classNameSec = classnames(styles.sec, className);
        return (React.createElement("div", { className: classNameSec }, this.renderInfo()));
    };
    UserInfo = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], UserInfo);
    return UserInfo;
}(React.Component));
exports.UserInfo = UserInfo;
exports.default = UserInfo;


/***/ }),

/***/ "TsEa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("dUoe");
var PagesLinks = /** @class */ (function (_super) {
    tslib_1.__extends(PagesLinks, _super);
    function PagesLinks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showRule = function () {
            new f2eGameUI.Dialog({
                classNames: {
                    component: "rule-pop"
                }
            });
        };
        return _this;
    }
    PagesLinks.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        var classNameSec = classnames(styles.sec, className);
        var urlParam = window.location.search;
        return (React.createElement("div", { className: classNameSec },
            React.createElement("a", { href: window._CONFIG["PAGES"]["olduser"] + urlParam, className: styles.old, target: "_blank", onClick: function (e) { return (_this.clickState("/OLD", "/老用户")); } }),
            React.createElement("a", { href: window._CONFIG["PAGES"]["newuser"] + urlParam, className: styles.new, target: "_blank", onClick: function (e) { return (_this.clickState("/NEW", "/新用户")); } })));
    };
    PagesLinks.prototype.clickState = function (eid, eid_desc) {
        f2eGame.port.statpid.clickStat({ eid: window.Global.statpidOption.eid + eid, eid_desc: window.Global.statpidOption.eid_desc + eid_desc });
    };
    PagesLinks = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], PagesLinks);
    return PagesLinks;
}(React.Component));
exports.PagesLinks = PagesLinks;
exports.default = PagesLinks;


/***/ }),

/***/ "UB8D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var ReactDOM = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var subpub = __webpack_require__("lZMG");
var fetch_1 = __webpack_require__("l51b");
var components_1 = __webpack_require__("OrGm");
// import { getPageRouteKey } from "./route";
var styles = __webpack_require__("I2I8");
var App = /** @class */ (function (_super) {
    tslib_1.__extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        //   签到
        _this.sign = function (taskAward) {
            var _a = _this.state, signTask = _a.signTask, signCount = _a.signCount, signHistory = _a.signHistory;
            var date = new Date().getFullYear() + "" + (new Date().getMonth() + 1) + "" + new Date().getDate();
            var signToday = false;
            signHistory.map(function (item, index) {
                if (item == date) {
                    signToday = true;
                }
            });
            if (signToday) {
                var dialog_1 = new f2eGameUI.Dialog({
                    classNames: {
                        component: 'min-pop'
                    },
                    content: "\u606D\u559C\u60A8\u83B7\u5F97 " + taskAward,
                    buttons: [{
                            className: "btn-y",
                            callback: function () {
                                dialog_1.close(true);
                            }
                        }]
                });
                return;
            }
            else {
                fetch_1.joinAndFinish(window._CONFIG['ACTCODE'], signTask.tasks[0].id, signTask.gameId, signTask.serverId)
                    .then(function (res) {
                    // 签到成功
                    if (res.status == 200) {
                        _this.setState({ signCount: _this.state.signCount + 1 });
                        var awards_1 = [];
                        res.data.awards.map(function (item, index) {
                            awards_1.push(item.awardName);
                        });
                        var dialog_2 = new f2eGameUI.Dialog({
                            classNames: {
                                component: 'min-pop'
                            },
                            content: "\u606D\u559C\u60A8\u83B7\u5F97 " + awards_1.join(' ') + " " + taskAward,
                            buttons: [{
                                    className: "btn-y",
                                    callback: function () {
                                        dialog_2.close(true);
                                    }
                                }]
                        });
                        // 签到失败
                    }
                    else {
                        var dialog_3 = new f2eGameUI.Dialog({
                            classNames: {
                                component: 'min-pop'
                            },
                            content: "\u606D\u559C\u60A8\u83B7\u5F97 " + taskAward,
                            buttons: [{
                                    className: "btn-y",
                                    callback: function () {
                                        dialog_3.close(true);
                                    }
                                }]
                        });
                    }
                });
            }
        };
        // 获取用户信息和历史绑定信息
        _this.getUserAndBindInfo = function (dialog) {
            fetch_1.fetchUserInfo()
                .then(function (res) {
                if (res.status == 200) {
                    _this.setState({ userInfo: res.data });
                }
            });
            fetch_1.getBindUsers()
                .then(function (res) {
                if (res.status == 200) {
                    if (res.data.binding !== null) {
                        _this.setState({ curBindUser: res.data.binding });
                    }
                    if (res.data.historys.length != 0) {
                        _this.setState({
                            historyBindUser: res.data.historys
                        });
                    }
                    // 是否弹窗提示
                    if (dialog) {
                        var dialog_4 = new f2eGameUI.Dialog({
                            classNames: {
                                component: "min-pop"
                            },
                            content: "刷新成功",
                            buttons: [{
                                    className: 'btn-y',
                                    callback: function () {
                                        dialog_4.close(true);
                                    }
                                }]
                        });
                    }
                }
            });
        };
        _this.state = {
            userInfo: {
                bindingNum: 0,
                enable: false,
                tickets: 0,
                scores: 0
            },
            curBindUser: {
                nickname: "",
                yyuid: "",
                scores: ""
            },
            historyBindUser: [
                {
                    nickname: "",
                    yyuid: "",
                    scores: ""
                }
            ],
            confData: [{
                    gameId: "",
                    serverId: "",
                    tasks: []
                }],
            countDownStart: 0,
            signTask: {
                gameId: "",
                serverId: "",
                tasks: []
            },
            signCount: 0,
            signHistory: []
        };
        return _this;
    }
    App.prototype.componentWillMount = function () {
        var _this = this;
        fetch_1.confTask3(window._CONFIG['ACTCODE'])
            .then(function (res) {
            if (res.status == 200) {
                var conf_1 = [];
                res.data.entrys.map(function (item, index) {
                    if (index < 3) {
                        conf_1.push({
                            gameId: item.gs.gameId,
                            serverId: item.gs.serverId,
                            tasks: item.tasks
                        });
                    }
                });
                _this.setState({
                    confData: conf_1,
                    countDownStart: res.data.serverTime,
                    signTask: {
                        gameId: res.data.entrys[3].gs.gameId,
                        serverId: res.data.entrys[3].gs.serverId,
                        tasks: res.data.entrys[3].tasks
                    }
                });
            }
        });
        fetch_1.fetchUserInfo()
            .then(function (res) {
            if (res.status == 200) {
                _this.setState({ userInfo: res.data });
            }
        })
            .then(function () {
            fetch_1.getBindUsers()
                .then(function (res) {
                if (res.status == 200) {
                    if (res.data.binding !== null) {
                        _this.setState({ curBindUser: res.data.binding });
                    }
                    if (res.data.historys.length != 0) {
                        _this.setState({
                            historyBindUser: res.data.historys
                        });
                    }
                }
            })
                .then(function (res) {
                var shareYyuid = Number(f2eGame.util.getParam('yyuid'));
                var curBindYyuid = _this.state.curBindUser.yyuid;
                f2eGame.port.udb.getUserInfo()
                    .then(function (res) {
                    if (!!shareYyuid && shareYyuid != res.yyid) {
                        if (curBindYyuid == shareYyuid)
                            return;
                        var dialog_5 = new f2eGameUI.Dialog({
                            classNames: {
                                component: "min-pop"
                            },
                            buttons: [{
                                    className: "btn-nobind",
                                    callback: function () {
                                        dialog_5.close(true);
                                    }
                                }, {
                                    className: "btn-bind",
                                    callback: function () {
                                        _this.bind(shareYyuid);
                                        dialog_5.close(true);
                                    }
                                }]
                        });
                        var contTips = "";
                        if (!!curBindYyuid) {
                            contTips = shareYyuid + "\u9080\u8BF7\u60A8\u89E3\u9664\u5DF2\u6709\u7ED1\u5B9A\uFF0C\u5E76\u7ED1\u5B9ATA\u4E3A\u60A8\u65B0\u7684\u7ED1\u5B9A\u597D\u53CB";
                        }
                        else {
                            contTips = shareYyuid + "\u9080\u8BF7\u60A8\u6210\u4E3ATA\u7684\u7ED1\u5B9A\u597D\u53CB\u3002\u7ED1\u5B9A\u540E\u5C06\u81EA\u52A8\u4E3ATA\u6295\u7968";
                        }
                        ReactDOM.render(React.createElement(components_1.Dialog, { shareYyuid: shareYyuid, curBindYyuid: curBindYyuid, contTips: contTips }), $('.f2e-dialog__body ')[0]);
                    }
                });
            });
        });
        f2eGame.port.task3.signHistory({
            actCode: window._CONFIG['ACTCODE']
        })
            .then(function (res) {
            if (res.status == 200) {
                _this.setState({
                    signCount: res.data.signCount,
                    signHistory: res.data.history
                });
            }
        });
    };
    App.prototype.bind = function (yyuid) {
        fetch_1.bindFriend(yyuid)
            .then(function (res) {
            var cont = "";
            if (res.status == 200 && res.data) {
                subpub.emit('bindSucc');
                cont = "绑定成功！";
            }
            else if (res.status == 551) {
                cont = res.message;
            }
            else {
                cont = "绑定失败！";
            }
            var dialog = new f2eGameUI.Dialog({
                classNames: {
                    component: "min-pop"
                },
                content: cont,
                buttons: [{
                        className: "btn-y",
                        callback: function () {
                            dialog.close(true);
                        }
                    }]
            });
        });
    };
    App.prototype.componentDidMount = function () {
        var _this = this;
        subpub.on('bindSucc', function () {
            fetch_1.getBindUsers()
                .then(function (res) {
                if (res.status == 200) {
                    _this.setState({
                        curBindUser: res.data.binding,
                        historyBindUser: res.data.historys
                    });
                }
            });
        });
        subpub.on("voteSucc", function () {
            _this.getUserAndBindInfo();
        });
        subpub.on("freshUserAndBindInfo", function () {
            _this.getUserAndBindInfo(true);
        });
        subpub.on('getTaskAward', function (e, param) {
            var taskId = param.taskId, gameId = param.gameId, serverId = param.serverId, taskName = param.taskName, x = param.x, y = param.y, noTips = param.noTips, isClick = param.isClick;
            var gameName = f2eGame.util.queryGame(gameId, "gameName");
            if (y == 0) {
                taskName = "体验游戏" + taskName + "分钟";
            }
            else {
                taskName = "等级达到" + taskName + "级";
            }
            if (_this.state.confData[x].tasks[y].taskStatus == 100)
                return;
            if (_this.state.confData[x].tasks[y].taskStatus == 1 && !noTips) {
                fetch_1.joinAndFinish(window._CONFIG['ACTCODE'], taskId, gameId, serverId)
                    .then(function (res) {
                    if (res.status == 200) {
                        var awards_2 = [];
                        res.data.awards.map(function (item, index) {
                            awards_2.push(item.awardName);
                        });
                        var confData = Object.assign([], _this.state.confData);
                        confData[x].tasks[y].taskStatus = 100;
                        _this.setState({ confData: confData });
                        _this.forceUpdate();
                        _this.getUserAndBindInfo();
                        // 游戏5分钟
                        if (y == 0) {
                            _this.sign(awards_2.join(' '));
                        }
                        else {
                            var dialog_6 = new f2eGameUI.Dialog({
                                classNames: {
                                    component: "min-pop"
                                },
                                content: "\u606D\u559C\u60A8\u83B7\u5F97 " + awards_2.join(' '),
                                buttons: [{
                                        className: "btn-y",
                                        callback: function () {
                                            dialog_6.close(true);
                                        }
                                    }]
                            });
                        }
                    }
                    else if (res.status == 411) {
                        var dialog_7 = new f2eGameUI.Dialog({
                            classNames: {
                                component: "min-pop"
                            },
                            content: "\u60A8\u4ECA\u65E5\u8FD8\u672A\u8FBE\u5230\u9886\u5956\u6761\u4EF6\u54E6\uFF01<br/>\u3010" + taskName + "\u3011\u53EF\u9886\u53D6",
                            buttons: [{
                                    className: "btn-continue",
                                    callback: function () {
                                        f2eGame.port.statpid.clickStat({ eid: window.Global.statpidOption.eid + "/FHYX", eid_desc: window.Global.statpidOption.eid_desc + "/返回游戏" });
                                        f2eGame.port.statpid.gameStat({
                                            eid: window.Global.statpidOption.eid + "/FHYX",
                                            eid_desc: window.Global.statpidOption.eid_desc + "/返回游戏",
                                            gameId: gameId,
                                            serverId: serverId,
                                            gameName: gameName
                                        });
                                        dialog_7.close(true);
                                    }
                                }]
                        });
                    }
                    else {
                        var dialog_8 = new f2eGameUI.Dialog({
                            classNames: {
                                component: "min-pop"
                            },
                            content: res.message,
                            buttons: [{
                                    className: "btn-y",
                                    callback: function () {
                                        dialog_8.close(true);
                                    }
                                }]
                        });
                    }
                });
                return;
            }
            else {
                if (isClick) {
                    f2eGame.port.statpid.clickStat({ eid: window.Global.statpidOption.eid + "/YX" + (x + 1) + "RW" + (y + 1), eid_desc: window.Global.statpidOption.eid_desc + "/游戏" + (x + 1) + "任务" + (y + 1) });
                }
                f2eGame.port.statpid.gameStat({
                    eid: window.Global.statpidOption.eid + "/YX" + (x + 1) + "RW" + (y + 1),
                    eid_desc: window.Global.statpidOption.eid_desc + "/游戏" + (x + 1) + "任务" + (y + 1),
                    gameId: gameId,
                    serverId: serverId,
                    gameName: gameName
                });
                fetch_1.joinAndFinish(window._CONFIG['ACTCODE'], taskId, gameId, serverId)
                    .then(function (res) {
                    if (res.status == 200) {
                        var awards_3 = [];
                        res.data.awards.map(function (item, index) {
                            awards_3.push(item.awardName);
                        });
                        var confData = Object.assign([], _this.state.confData);
                        confData[x].tasks[y].taskStatus = 100;
                        _this.setState({ confData: confData });
                        _this.forceUpdate();
                        _this.getUserAndBindInfo();
                        // 游戏5分钟
                        if (y == 0) {
                            _this.sign(awards_3.join(' '));
                        }
                        else {
                            var dialog_9 = new f2eGameUI.Dialog({
                                classNames: {
                                    component: "min-pop"
                                },
                                content: "\u606D\u559C\u60A8\u83B7\u5F97 " + awards_3.join(' '),
                                buttons: [{
                                        className: "btn-y",
                                        callback: function () {
                                            dialog_9.close(true);
                                        }
                                    }]
                            });
                        }
                    }
                    else {
                        var confData = Object.assign([], _this.state.confData);
                        confData[x].tasks[y].taskStatus = 1;
                        _this.setState({ confData: confData });
                        _this.forceUpdate();
                    }
                });
            }
        });
    };
    App.prototype.render = function () {
        var className = this.props.className;
        var _a = this.state, userInfo = _a.userInfo, historyBindUser = _a.historyBindUser, curBindUser = _a.curBindUser, confData = _a.confData, countDownStart = _a.countDownStart, signCount = _a.signCount;
        var classNameSec = classnames(styles.container, className, "f-cb");
        // const active: string = getPageRouteKey();
        return (React.createElement("div", { className: classNameSec },
            React.createElement("div", { className: styles.rule_package },
                React.createElement(components_1.Rules, null),
                React.createElement(components_1.MyPackage, null)),
            React.createElement(components_1.UserInfo, null),
            React.createElement(components_1.PagesLinks, null),
            React.createElement("div", { className: styles.top },
                React.createElement(components_1.Dynamics, null),
                React.createElement(components_1.CountDown, { countDownStart: countDownStart }),
                React.createElement(components_1.NewUserTitle, { signCount: signCount })),
            React.createElement("div", { className: styles.main },
                React.createElement(components_1.NewUserTask, { userInfo: userInfo, confData: confData, curBindUser: curBindUser, signCount: signCount })),
            React.createElement("div", { className: styles.bottom },
                React.createElement("div", { className: styles.bottom_left },
                    React.createElement(components_1.PointInfo, { userInfo: userInfo }),
                    React.createElement(components_1.SearchBox, { curBindUser: curBindUser })),
                React.createElement("div", { className: styles.bottom_right },
                    React.createElement(components_1.BindFriends, { curBindUser: curBindUser, historyBindUser: historyBindUser, confData: confData, userInfo: userInfo })))));
    };
    App = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], App);
    return App;
}(React.Component));
exports.App = App;
exports.default = App;


/***/ }),

/***/ "VhSe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var ReactDOM = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("/3Ro");
var fetch_1 = __webpack_require__("l51b");
var subpub = __webpack_require__("lZMG");
var components_1 = __webpack_require__("OrGm");
var SearchBox = /** @class */ (function (_super) {
    tslib_1.__extends(SearchBox, _super);
    function SearchBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            searchValue: "",
            oldUsers: [{
                    yyuid: "",
                    passport: ""
                }],
            curYyuid: "",
        };
        return _this;
    }
    SearchBox.prototype.render = function () {
        var className = this.props.className;
        var classNameSec = classnames(styles.sec, className);
        var _a = this.state, searchValue = _a.searchValue, oldUsers = _a.oldUsers;
        return (React.createElement("div", { className: classNameSec },
            "\u641C\u7D22\u6846",
            React.createElement("div", { className: styles.search_box },
                React.createElement("input", { type: "text", className: styles.search, value: searchValue, onKeyPress: this.searchUsers.bind(this), onChange: this.changeValue.bind(this), placeholder: "输入大使账号+回车键" }))));
    };
    SearchBox.prototype.renderSearchUsers = function (item, index) {
        var _this = this;
        return (React.createElement("li", { onClick: function (e) { return (_this.chooseUser(item.yyuid, item.passport)); } }, item.passport));
    };
    SearchBox.prototype.changeValue = function (e) {
        var value = e.target.value || this.state.searchValue;
        this.setState({ searchValue: value });
    };
    SearchBox.prototype.searchUsers = function (e) {
        var _this = this;
        if (e.keyCode != 13) {
            return;
        }
        if (this.searchDialog) {
            this.searchDialog.close(true);
        }
        var value = e.target.value || this.state.searchValue;
        this.setState({ searchValue: value });
        if (!!value) {
            fetch_1.searchOldUser(value)
                .then(function (res) {
                if (res.status == 200) {
                    _this.setState({ oldUsers: res.data });
                    // 回车直接绑定
                    if (res.data.length > 0) {
                        _this.chooseUser(res.data[0].yyuid, res.data[0].passport);
                    }
                    else {
                        var dialog_1 = _this.searchDialog = new f2eGameUI.Dialog({
                            classNames: {
                                component: "min-pop"
                            },
                            content: "查无此人",
                            buttons: [{
                                    className: "btn-y",
                                    callback: function () {
                                        dialog_1.close(true);
                                    }
                                }],
                        });
                    }
                }
            });
            // .then((res: any) => {
            //     this.showSearchList(true)
            // })
        }
        else {
            this.setState({
                oldUsers: [{
                        yyuid: "",
                        passport: ""
                    }],
                searchValue: ""
            });
            return;
        }
    };
    // 选择要绑定用户
    SearchBox.prototype.chooseUser = function (yyuid, passport) {
        var _this = this;
        this.setState({ curYyuid: yyuid, searchValue: passport });
        var shareYyuid = Number(yyuid);
        var curBindYyuid = this.props.curBindUser.yyuid;
        if (!!shareYyuid) {
            if (curBindYyuid == shareYyuid) {
                var dialog_2 = this.searchDialog = new f2eGameUI.Dialog({
                    classNames: {
                        component: "min-pop"
                    },
                    content: "您已经绑定该用户",
                    buttons: [{
                            className: 'btn-y',
                            callback: function () {
                                dialog_2.close(true);
                            }
                        }]
                });
                return;
            }
            ;
            var dialog_3 = this.searchDialog = new f2eGameUI.Dialog({
                classNames: {
                    component: "min-pop"
                },
                buttons: [{
                        className: "btn-nobind",
                        callback: function () {
                            dialog_3.close(true);
                        }
                    }, {
                        className: "btn-bind",
                        callback: function () {
                            _this.bind(shareYyuid);
                            dialog_3.close(true);
                        }
                    }]
            });
            var contTips = "";
            if (!!curBindYyuid) {
                contTips = "\u662F\u5426\u89E3\u9664\u5DF2\u6709\u7ED1\u5B9A\uFF0C\u5E76\u7ED1\u5B9A" + shareYyuid + "\u4E3A\u60A8\u65B0\u7684\u7ED1\u5B9A\u597D\u53CB\uFF1F";
            }
            else {
                contTips = "\u662F\u5426\u7ED1\u5B9ATA\u4E3A\u60A8\u7684\u6E38\u620F\u597D\u53CB\u3002\u7ED1\u5B9A\u540E\u5C06\u81EA\u52A8\u4E3ATA\u6295\u7968";
            }
            ReactDOM.render(React.createElement(components_1.Dialog, { shareYyuid: shareYyuid, curBindYyuid: curBindYyuid, contTips: contTips }), $('.f2e-dialog__body ')[0]);
        }
    };
    SearchBox.prototype.bind = function (yyuid) {
        fetch_1.bindFriend(yyuid)
            .then(function (res) {
            var cont = "";
            if (res.status == 200 && res.data) {
                cont = "绑定成功！";
                subpub.emit('bindSucc');
            }
            else if (res.status == 551) {
                cont = res.message;
            }
            else {
                cont = "绑定失败！";
            }
            var dialog = new f2eGameUI.Dialog({
                classNames: {
                    component: "min-pop"
                },
                content: cont,
                buttons: [{
                        className: "btn-y",
                        callback: function () {
                            dialog.close(true);
                        }
                    }]
            });
        });
    };
    SearchBox = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], SearchBox);
    return SearchBox;
}(React.Component));
exports.SearchBox = SearchBox;
exports.default = SearchBox;


/***/ }),

/***/ "Wska":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Dialog_1 = __webpack_require__("pfbM");
exports.default = Dialog_1.default;


/***/ }),

/***/ "XnEg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"MyPackage__sec__RVwBH9Zu"};

/***/ }),

/***/ "YDwv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("gQuc");
var subpub = __webpack_require__("lZMG");
var PointInfo = /** @class */ (function (_super) {
    tslib_1.__extends(PointInfo, _super);
    function PointInfo(props) {
        var _this = _super.call(this, props) || this;
        _this.freshUserAndBindInfo = function () {
            subpub.emit('freshUserAndBindInfo');
        };
        return _this;
    }
    PointInfo.prototype.render = function () {
        var _a = this.props, className = _a.className, userInfo = _a.userInfo;
        var classNameSec = classnames(styles.sec, className);
        return (React.createElement("div", { className: classNameSec },
            "\u5F53\u524D\u6E38\u620F\u7968\uFF1A",
            React.createElement("span", { className: styles.points }, userInfo.tickets),
            React.createElement("div", { className: styles.fresh, onClick: this.freshUserAndBindInfo })));
    };
    PointInfo = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], PointInfo);
    return PointInfo;
}(React.Component));
exports.PointInfo = PointInfo;
exports.default = PointInfo;


/***/ }),

/***/ "YyqG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"Dialog__sec__3005mHLD","changebind_box":"Dialog__changebind_box__2W6cp3L9","user_info":"Dialog__user_info__-Dg63HiA","info_tips":"Dialog__info_tips__1okpNGlT","user_img":"Dialog__user_img__15NOtVtj","img_mask":"Dialog__img_mask__31OJUD1a","user_name":"Dialog__user_name__R4s26Qnz","change_arrow":"Dialog__change_arrow__1m6HuxV0","tips":"Dialog__tips__2GZU1F8d","bind_box":"Dialog__bind_box__14tYykx2","bind_tips":"Dialog__bind_tips__1gEvxm-7"};

/***/ }),

/***/ "alqh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CountDown_1 = __webpack_require__("c+pw");
exports.default = CountDown_1.default;


/***/ }),

/***/ "aovt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.dataAPI = {
    // 用户信息
    userInfo: "http://gxhd.game.yy.com/zhhy/info.do",
    // 用户排名
    getRanks: "http://gxhd.game.yy.com/zhhy/getRank.do",
    //激活老用户资格
    activateOldStatus: "http://gxhd.game.yy.com/zhhy/register.do",
    // 查询老用户
    serchOldUsers: "http://gxhd.game.yy.com/zhhy/search.do",
    // 获取用户当期投票记录
    voteHistory: "http://gxhd.game.yy.com/zhhy/voteHistory.do",
    // 绑定好友
    bindFriend: "http://gxhd.game.yy.com/zhhy/bind.do",
    // 投票
    voteTicket: "http://gxhd.game.yy.com/zhhy/vote.do",
    getNickname: "http://gxhd.game.yy.com/zhhy/getNickname.do"
};
exports.default = exports.dataAPI;


/***/ }),

/***/ "bj8f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c+pw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("/0D4");
var CountDown = /** @class */ (function (_super) {
    tslib_1.__extends(CountDown, _super);
    function CountDown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountDown.prototype.render = function () {
        var className = this.props.className;
        var classNameSec = classnames(styles.sec, className);
        return (React.createElement("div", { className: classNameSec },
            React.createElement("p", { className: styles.label }, "\u4EFB\u52A1\u91CD\u7F6E\u5012\u8BA1\u65F6"),
            React.createElement("p", { className: classnames(styles.time), ref: "countdown" })));
    };
    CountDown.prototype.componentDidUpdate = function () {
        var year = new Date().getFullYear();
        var month = new Date().getMonth() + 1;
        var date = new Date().getDate() + 1;
        var finalTime = new Date(year + '/' + month + '/' + date + ' 00:00:00').getTime();
        new f2eGameUI.CountDown({
            $element: $(this.refs.countdown)[0],
            nowTime: this.props.countDownStart,
            finalTime: finalTime,
            modules: {
                day: {
                    show: false
                },
                hour: {
                    unit: ":"
                },
                minute: {
                    unit: ":"
                },
                second: {
                    unit: ""
                }
            }
        });
    };
    CountDown = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], CountDown);
    return CountDown;
}(React.Component));
exports.CountDown = CountDown;
exports.default = CountDown;


/***/ }),

/***/ "dUoe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"PagesLinks__sec__2DjwuNb1","new":"PagesLinks__new__1-IZ_GmK"};

/***/ }),

/***/ "g/92":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"BindFriends__sec__27bDXzkz","btn_left":"BindFriends__btn_left__M9B8HZoa","btn_right":"BindFriends__btn_right__2E1W4bo8","content":"BindFriends__content__3G1kJDTO","cur":"BindFriends__cur__2gQufHC4","nocur":"BindFriends__nocur__1akShG62","totalticket":"BindFriends__totalticket__33ywaD8a","friend_pic":"BindFriends__friend_pic__3SYOE0hZ","pic_mask":"BindFriends__pic_mask__1xAXazrN","btn_send":"BindFriends__btn_send__3XMtYS5R","btn_changebind":"BindFriends__btn_changebind__3HTf0gnp","add_pic":"BindFriends__add_pic__2071F1nb"};

/***/ }),

/***/ "gQuc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"PointInfo__sec__gKhWrNGX","points":"PointInfo__points__Dv95h1wn","fresh":"PointInfo__fresh__3J7fZDOi"};

/***/ }),

/***/ "l51b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = __webpack_require__("aovt");
var subpub = __webpack_require__("lZMG");
/**
 * 从服务器检索数据
 *
 * @export
 * @param {*} settings
 * @returns Promise
 */
function fetch(settings) {
    return new Promise(function (resolve, reject) {
        subpub.emit('loading', true);
        $.ajax($.extend({
            dataType: "jsonp",
            timeout: 10000,
            type: "get",
            success: function (res) {
                subpub.emit('loading', false);
                resolve(res);
            },
            error: function (res) {
                subpub.emit('loading', false);
                reject({ errmsg: '您的网络异常，请稍后重试！' });
            },
        }, settings || {}));
    });
}
exports.fetch = fetch;
/**
 * 获取用户信息
 *
 * @export
 * @returns
 */
function fetchUserInfo() {
    var options = {
        url: api_1.default.userInfo,
    };
    return fetch(options);
}
exports.fetchUserInfo = fetchUserInfo;
/**
 * 获取用户排行榜
 */
function fetchRanks() {
    var options = {
        url: api_1.default.getRanks,
    };
    return fetch(options);
}
exports.fetchRanks = fetchRanks;
/**
 * 激活老用户资格
 */
function ActivateOldStatus() {
    var options = {
        url: api_1.default.activateOldStatus,
    };
    return fetch(options);
}
exports.ActivateOldStatus = ActivateOldStatus;
function confTask3(actId) {
    var options = {
        actCode: actId,
        isLogin: true
    };
    return f2eGame.port.task3.conf(options);
}
exports.confTask3 = confTask3;
function joinAndFinish(actId, taskId, gameId, serverId) {
    var options = {
        actCode: actId,
        taskId: taskId,
        times: 1,
        gameId: gameId,
        serverId: serverId
    };
    return f2eGame.port.task3.joinAndFinish(options);
}
exports.joinAndFinish = joinAndFinish;
// 查询老用户
function searchOldUser(value) {
    var options = {
        data: { word: value },
        url: api_1.default.serchOldUsers
    };
    return fetch(options);
}
exports.searchOldUser = searchOldUser;
// // 获取用户当期投票记录
function getBindUsers() {
    var options = {
        url: api_1.default.voteHistory
    };
    return fetch(options);
}
exports.getBindUsers = getBindUsers;
// 绑定好友
function bindFriend(bindyyuid) {
    var options = {
        data: {
            inviter: bindyyuid
        },
        url: api_1.default.bindFriend
    };
    return fetch(options);
}
exports.bindFriend = bindFriend;
// 投票
function voteTicket() {
    var options = {
        url: api_1.default.voteTicket
    };
    return fetch(options);
}
exports.voteTicket = voteTicket;
// 获取用户昵称
function fetchNickname(yyuid) {
    var options = {
        url: api_1.default.getNickname,
        data: {
            yyuid: yyuid
        }
    };
    return fetch(options);
}
exports.fetchNickname = fetchNickname;
// /**
//  * 检索任务
//  *
//  * @export
//  * @param {string} actId
//  * @returns Promise
//  */
// export function fetchTask3(actId: string) {
//   const options = {
//     data: { act: actId },
//     url: dataAPI.task4366,
//   };
//   return fetch(options);
// }
// /**
//  * joinAndFinish
//  * 
//  * @export
//  * @param {*} params 
//  * @returns 
//  */
// export function joinAndFinish(params: any) {
//   const options = {
//     data: params,
//     url: dataAPI.jfinish,
//   };
//   return fetch(options);
// }
// /**
//  * 检索商品
//  * 
//  * @export
//  * @param {*} params 
//  * @returns 
//  */
// export function fetchMall(params: any) {
//   const options = {
//     data: params,
//     url: dataAPI.mallSearch,
//   };
//   return fetch(options);
// }
// /**
//  * 检索兑换记录
//  * 
//  * @export
//  * @param {*} params 
//  * @returns 
//  */
// export function fetchExchangeRecord() {
//   const { mallId } = appState;
//   const options = {
//     data: {
//       mallId,
//       page: 0,
//       pageSize: 10000,
//     },
//     url: dataAPI.exchangeList,
//   };
//   return fetch(options);
// }
// /**
//  * 检索商品详情
//  * 
//  * @export
//  * @param {number} id 
//  * @returns 
//  */
// export function fetchProductDetail(id: number) {
//   const options = {
//     data: {
//       mallGoodsId: id,
//     },
//     url: dataAPI.productDetail,
//   };
//   return fetch(options);
// }
// export function fetchBuyProduct(id: number, realName?: string, phone?: string, address?: string, yyim?: string) {
//   const options = {
//     data: {
//       mallGoodsId: id,
//       realName,
//       phone,
//       address,
//       yyim,
//     },
//     url: dataAPI.buyProduct,
//   };
//   return fetch(options);
// }
// /**
//  * 拉取手机验证码
//  * 
//  * @export
//  * @param {string} phone 
//  * @returns 
//  */
// export function fetchPhoneCode(phone: string) {
//   const options = {
//     data: { mobile: phone },
//     url: dataAPI.sendPhoneCode,
//   };
//   return fetch(options);
// }
// /**
//  * 请求服务器绑定手机
//  * 
//  * @export
//  * @param {string} token 
//  * @param {string} smscode 
//  * @returns 
//  */
// export function requestBindMobile(token: string, smscode: string) {
//   const options = {
//     data: { token, smscode },
//     url: dataAPI.bindMobile,
//   };
//   return fetch(options);
// }
// /**
//  * 拉取邮箱验证码
//  * 
//  * @export
//  * @param {string} email 
//  * @returns 
//  */
// export function fetchEmailCode(email: string) {
//   const options = {
//     data: { email },
//     url: dataAPI.sendEmailCode,
//   };
//   return fetch(options);
// }
// /**
//  * 请求服务器绑定邮箱
//  * 
//  * @export
//  * @param {string} token 
//  * @param {string} emailcode 
//  * @returns 
//  */
// export function requestBindEmail(token: string, emailcode: string) {
//   const options = {
//     data: { token, emailcode },
//     url: dataAPI.bindEmail,
//   };
//   return fetch(options);
// }
// /**
//  * 请求gslist
//  * 
//  * @export
//  * @param {*} params 
//  * @returns 
//  */
// export function fetchGSList(params: string) {
//   const options = {
//     url: `${dataAPI.gslist}?jsonp&online&${params}`,
//     jsonpCallback: 'jsonpcallback',
//   };
//   return fetch(options);
// }
// /**
//  * 拉我的积分
//  * 
//  * @export
//  * @returns 
//  */
// export function fetchMyPoint() {
//   const options = {
//     url: `${dataAPI.myPoint}?prizeId=PRIZE_CENTER-4366JF`,
//   };
//   return fetch(options);
// }
// /**
//  * 拉取我的中奖记录
//  * 
//  * @export
//  * @returns 
//  */
// export function fetchMixPackage() {
//   const {
//     actIdDailyModule,
//     actIdGameModule,
//     actIdLotteryModule,
//     actIdNewModule
//   } = appState;
//   const act = [actIdDailyModule,
//     actIdGameModule,
//     actIdLotteryModule,
//     actIdNewModule].join(',');
//   const options = {
//     url: `${dataAPI.mixPackage}`,
//     data: {
//       act,
//       pageId: 1,
//       pageSize: 10000
//     }
//   };
//   return fetch(options);
// } 


/***/ }),

/***/ "lZMG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * mitt 订阅事件
 *
 * @export
 * @param {string} name
 * @param {(e?: any) => any} call
 */
function on(name, call) {
    $(document).off(name);
    $(document).on(name, call);
}
exports.on = on;
/**
 * mitt 发布事件
 *
 * @export
 * @param {string} name
 * @param {*} [e]
 */
function emit(name, params) {
    $(document).trigger(name, params);
}
exports.emit = emit;
/**
 * 注销事件
 *
 * @export
 * @param {string} name
 */
function off(name) {
    $(document).off(name);
}
exports.off = off;


/***/ }),

/***/ "lpMy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("tj9R");
var subpub = __webpack_require__("lZMG");
var NewUserTask = /** @class */ (function (_super) {
    tslib_1.__extends(NewUserTask, _super);
    function NewUserTask(props) {
        var _this = _super.call(this, props) || this;
        _this.islogin = false;
        //   渲染游戏列表
        _this.renderGamsList = function (item, index) {
            if (!item.gameId)
                return;
            var gameName = f2eGame.util.queryGame(item.gameId, "gameName");
            var recommensTips = f2eGame.util.queryGame(item.gameId, "recommendTips");
            var online = f2eGame.util.queryGame(item.gameId, "online");
            var onlineNum = String(online).split("");
            var curIndex = _this.state.curIndex;
            return (React.createElement("div", { className: classnames(styles.games, styles["games" + (index + 1)]), onClick: function (e) { return _this.chooseGame(index); } },
                React.createElement("div", { className: styles.games_pic },
                    React.createElement("img", { src: "http://lobby.dwstatic.com/goa/pic/o/" + item.gameId.toLowerCase() + "_76.png", alt: "", width: "59", height: "59" }),
                    React.createElement("div", { className: styles.game_pic_mask })),
                React.createElement("div", { className: styles.game_info },
                    React.createElement("p", { className: styles.game_name }, gameName),
                    React.createElement("p", { className: styles.games_desc }, recommensTips),
                    React.createElement("div", { className: styles.games_num },
                        onlineNum.map(function (item, index) { return (_this.renderOnlineNum(item, index)); }),
                        React.createElement("span", null, "\u4EBA\u73A9"))),
                React.createElement("div", { className: curIndex == index ? styles.games_mask : "" })));
        };
        //   渲染在线人数
        _this.renderOnlineNum = function (item, index) {
            return (React.createElement("span", { className: styles.num }, item));
        };
        // 渲染不同游戏任务列表
        _this.renderGameTaskList = function (item, index) {
            if (!item.gameId)
                return;
            var curIndex = _this.state.curIndex;
            var signCount = _this.props.signCount;
            var classNameshow = classnames(styles['tasklist' + (index + 1)]);
            if (curIndex == index) {
                classNameshow = classnames(styles['tasklist' + (index + 1)], styles.show);
            }
            var imgUrl = window.Global.baseNcImgUrl + "/awards/" + window.Global.AW + "/day" + (signCount + 1);
            return (React.createElement("li", { className: classNameshow },
                React.createElement("div", { className: styles.tasklist_timetasks },
                    React.createElement("span", { className: styles.task_name }, item.tasks[0].showName),
                    React.createElement("img", { src: imgUrl + "/exprientawards/award" + (index + 1) + ".png", alt: "", height: "95" }),
                    React.createElement("div", { className: item.tasks[0].taskStatus == 0 ? styles.btn_get : item.tasks[0].taskStatus == 1 ? styles.btn_getting : styles.btn_got, onClick: function (e) { return (_this.getAward(item.tasks[0].id, item.gameId, item.serverId, item.tasks[0].showName, index, 0)); } })),
                React.createElement("div", { className: styles.tasklist_leveltasks },
                    React.createElement("span", { className: styles.task_name }, item.tasks[1].showName),
                    React.createElement("img", { src: imgUrl + "/levelawards/award" + (index + 1) + ".png", alt: "", height: "95" }),
                    React.createElement("div", { className: item.tasks[1].taskStatus == 0 ? styles.btn_get : item.tasks[1].taskStatus == 1 ? styles.btn_getting : styles.btn_got, onClick: function (e) { return (_this.getAward(item.tasks[1].id, item.gameId, item.serverId, item.tasks[1].showName, index, 1)); } }))));
        };
        _this.state = {
            curIndex: 0,
            confData: _this.props.confData,
        };
        return _this;
    }
    NewUserTask.prototype.componentWillMount = function () {
        var _this = this;
        window.Global.isLogin(function () {
            _this.islogin = true;
        });
    };
    NewUserTask.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ confData: nextProps.confData });
        this.forceUpdate();
    };
    NewUserTask.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        var classNameSec = classnames(styles.sec, className);
        var _a = this.state, curIndex = _a.curIndex, confData = _a.confData;
        return (React.createElement("div", { className: classNameSec },
            React.createElement("ul", { className: styles.tasklist }, confData.map(function (item, index) { return (_this.renderGameTaskList(item, index)); })),
            React.createElement("div", { className: styles.gamesbox }, confData.map(function (item, index) { return (_this.renderGamsList(item, index)); }))));
    };
    // 选择游戏
    NewUserTask.prototype.chooseGame = function (index) {
        this.setState({ curIndex: index });
    };
    //   领取奖励
    NewUserTask.prototype.getAward = function (taskId, gameId, serverId, taskName, x, y) {
        var options = {
            taskId: taskId,
            gameId: gameId,
            serverId: serverId,
            taskName: taskName,
            x: x,
            y: y,
            noTips: false,
            isClick: true
        };
        if (this.islogin) {
            subpub.emit('getTaskAward', options);
        }
        else {
            f2eGame.port.udb.login({
                type: "YYQ"
            });
        }
    };
    NewUserTask = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], NewUserTask);
    return NewUserTask;
}(React.Component));
exports.NewUserTask = NewUserTask;
exports.default = NewUserTask;


/***/ }),

/***/ "m+Ry":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"NewUserTitle__sec__3O8xtImG","title_con":"NewUserTitle__title_con__13kKMlrq","border_left":"NewUserTitle__border_left__1kInQZgs","border_right":"NewUserTitle__border_right__3JI9FsCp"};

/***/ }),

/***/ "mt4q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"Dynamics__sec__245XTuFG","red":"Dynamics__red__1koj3Cs9"};

/***/ }),

/***/ "nQQ4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NewUserTask_1 = __webpack_require__("lpMy");
exports.default = NewUserTask_1.default;


/***/ }),

/***/ "pfbM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var styles = __webpack_require__("YyqG");
var fetch_1 = __webpack_require__("l51b");
var Dialog = /** @class */ (function (_super) {
    tslib_1.__extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            curBindNickName: "",
            shareNickName: ""
        };
        return _this;
    }
    Dialog.prototype.componentWillMount = function () {
        var _this = this;
        if (!!this.props.curBindYyuid) {
            fetch_1.fetchNickname(this.props.curBindYyuid)
                .then(function (res) {
                _this.setState({
                    curBindNickName: res.data
                });
            });
        }
        fetch_1.fetchNickname(this.props.shareYyuid)
            .then(function (res) {
            _this.setState({
                shareNickName: res.data
            });
        });
    };
    Dialog.prototype.render = function () {
        // const {className} =this.props;
        // const classNameSec=classnames(styles.sec,className);
        var _a = this.state, curBindNickName = _a.curBindNickName, shareNickName = _a.shareNickName;
        var _b = this.props, curBindYyuid = _b.curBindYyuid, shareYyuid = _b.shareYyuid, contTips = _b.contTips;
        return (React.createElement("div", { className: styles.sec }, this.renderTemp(curBindYyuid, shareYyuid, contTips, curBindNickName, shareNickName)));
    };
    // 渲染模板
    Dialog.prototype.renderTemp = function (curBindYyuid, shareYyuid, contTips, curBindNickName, shareNickName) {
        if (!!curBindYyuid) {
            return this.changeBindTemp(curBindYyuid, shareYyuid, contTips, curBindNickName, shareNickName);
        }
        else {
            return this.bindTemp(shareYyuid, contTips, shareNickName);
        }
    };
    // 渲染改绑模板
    Dialog.prototype.changeBindTemp = function (curBindYyuid, shareYyuid, contTips, curBindNickName, shareNickName) {
        contTips = contTips.replace(shareYyuid, shareNickName);
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.changebind_box },
                React.createElement("div", { className: styles.user_info },
                    React.createElement("p", { className: styles.info_tips }, "\u5F53\u524D\u7ED1\u5B9A"),
                    React.createElement("div", { className: styles.user_img },
                        React.createElement("img", { src: "http://image.open.yy.com/avatar/" + curBindYyuid, alt: "", width: "66", height: "66" }),
                        React.createElement("div", { className: styles.img_mask })),
                    React.createElement("div", { className: styles.user_name }, curBindNickName)),
                React.createElement("div", { className: styles.change_arrow }),
                React.createElement("div", { className: styles.user_info },
                    React.createElement("p", { className: styles.info_tips }, "\u65B0\u7ED1\u5B9A"),
                    React.createElement("div", { className: styles.user_img },
                        React.createElement("img", { src: "http://image.open.yy.com/avatar/" + shareYyuid, alt: "", width: "66", height: "66" }),
                        React.createElement("div", { className: styles.img_mask })),
                    React.createElement("div", { className: styles.user_name }, shareNickName))),
            React.createElement("div", { className: styles.tips }, contTips)));
    };
    // 渲染绑定模板
    Dialog.prototype.bindTemp = function (shareYyuid, contTips, shareNickName) {
        contTips = contTips.replace(shareYyuid, shareNickName);
        return (React.createElement("div", { className: styles.bind_box },
            React.createElement("div", { className: styles.user_info },
                React.createElement("div", { className: styles.user_img },
                    React.createElement("img", { src: "http://image.open.yy.com/avatar/" + shareYyuid, alt: "", width: "66", height: "66" }),
                    React.createElement("div", { className: styles.img_mask })),
                React.createElement("div", { className: styles.user_name }, shareNickName)),
            React.createElement("div", { className: styles.bind_tips }, contTips)));
    };
    Dialog = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], Dialog);
    return Dialog;
}(React.Component));
exports.Dialog = Dialog;
exports.default = Dialog;


/***/ }),

/***/ "qMEF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
__webpack_require__("uMhA");
__webpack_require__("bj8f");
// import './third/json2';
// import './third/jPages';
var React = __webpack_require__("HDwS");
var ReactDOM = __webpack_require__("HDwS");
// import { configRoute } from "./route";
var App_1 = __webpack_require__("UB8D");
var global_1 = __webpack_require__("C1vT");
window.Global = global_1.default;
function start() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            // await userInfoToAppState();
            return [2 /*return*/, global_1.default.init()];
        });
    });
}
function render() {
    ReactDOM.render(React.createElement(App_1.default, null), document.getElementById("appzhhy"), function () {
        // Spinner.show({}, $('#app4366V3_1'));
        // loadSuccessNotify();
    });
}
exports.render = render;
window.onload = function () {
    start()
        .then(function () {
        // configRoute();
        render();
    })
        .catch(function (err) {
        if (err === void 0) { err = {}; }
        if (err.errmsg || err.message) {
            // dialogTips(err.errmsg || err.message);
            console.error(err);
        }
        // alert(JSON.stringify(err));
    });
};


/***/ }),

/***/ "qbvT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sec":"UserInfo__sec__1qkvp1bn"};

/***/ }),

/***/ "tj9R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"show":"NewUserTask__show__2hrSWjCp","sec":"NewUserTask__sec__3Qn-Sndp","tasklist":"NewUserTask__tasklist__2Mmz4XmF","tasklist_leveltasks":"NewUserTask__tasklist_leveltasks__G8Nz7ZEX","btn_get":"NewUserTask__btn_get__ZFX-EnHW","btn_getting":"NewUserTask__btn_getting__2zCLwYmq","btn_got":"NewUserTask__btn_got__2BtNJ21d","tasklist1":"NewUserTask__tasklist1__3DcrpjWj","tasklist_timetasks":"NewUserTask__tasklist_timetasks__2T2muePp","tasklist2":"NewUserTask__tasklist2__1_gfBxbY","tasklist3":"NewUserTask__tasklist3__g8rjfVWG","gamesbox":"NewUserTask__gamesbox__P44ef0G5","games":"NewUserTask__games__1Q2L8CvB","games_mask":"NewUserTask__games_mask__1QwCbVOm","games1":"NewUserTask__games1__22TMeIWf","game_pic_mask":"NewUserTask__game_pic_mask__2dLCJ7F9","games2":"NewUserTask__games2__TCn-uuBx","games3":"NewUserTask__games3__1ImYkthn","games_pic":"NewUserTask__games_pic__2HOYp-QC","game_info":"NewUserTask__game_info__3DpCTRC1","game_name":"NewUserTask__game_name__1PUMBIr1","games_desc":"NewUserTask__games_desc__2RThLNH8","games_num":"NewUserTask__games_num__1_LtFofG","num":"NewUserTask__num__1xbE9zMB"};

/***/ }),

/***/ "xFlA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("2IiS");
var Rules = /** @class */ (function (_super) {
    tslib_1.__extends(Rules, _super);
    function Rules() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showRule = function () {
            var context = "";
            window._CONFIG["RULES"].map(function (item, index) {
                context += "<p>" + item + "</p>";
            });
            new f2eGameUI.Dialog({
                classNames: {
                    component: "rule-pop"
                },
                content: context
            });
            $('.f2e-dialog__body')['mCustomScrollbar']({
                scrollInertia: 50,
                scrollButtons: {
                    enable: true
                },
                callbacks: {
                    whileScrollingInterval: 10
                }
            });
        };
        return _this;
    }
    Rules.prototype.render = function () {
        var className = this.props.className;
        var classNameSec = classnames(styles.sec, className);
        return (React.createElement("div", { className: classNameSec, onClick: this.showRule, ref: "rules" }));
    };
    Rules = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], Rules);
    return Rules;
}(React.Component));
exports.Rules = Rules;
exports.default = Rules;


/***/ }),

/***/ "y0tF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("PSuj");
var React = __webpack_require__("HDwS");
var pure_render_deepcompare_decorator_1 = __webpack_require__("HzYZ");
var classnames = __webpack_require__("HW6M");
var styles = __webpack_require__("m+Ry");
var NewUserTitle = /** @class */ (function (_super) {
    tslib_1.__extends(NewUserTitle, _super);
    function NewUserTitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTitle = function () {
            var signCount = _this.props.signCount;
            return {
                __html: "<p>" + window._CONFIG['TITLES']['day' + (signCount + 1)] + "</p>"
            };
        };
        return _this;
    }
    NewUserTitle.prototype.render = function () {
        var className = this.props.className;
        var classNameSec = classnames(styles.sec, className);
        return (React.createElement("div", { className: classNameSec },
            React.createElement("div", { className: styles.border_left }),
            React.createElement("div", { className: styles.title_con, dangerouslySetInnerHTML: this.renderTitle() }),
            React.createElement("div", { className: styles.border_right })));
    };
    NewUserTitle = tslib_1.__decorate([
        pure_render_deepcompare_decorator_1.default
    ], NewUserTitle);
    return NewUserTitle;
}(React.Component));
exports.NewUserTitle = NewUserTitle;
exports.default = NewUserTitle;


/***/ })

},[0]);


// WEBPACK FOOTER //
// app.61af5172.js